"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * © 2023 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("../../styled-components");
const Base_1 = require("../Base");
function Download({ size = 20, title = "Download", fill }) {
    const theme = (0, styled_components_1.useTheme)();
    fill = fill || theme.icon;
    return (react_1.default.createElement(Base_1.Base, { smooth: true, size: size, fill: fill, title: title },
        react_1.default.createElement("path", { d: "M7,1L9,1 9,8 11,8 8,12 5,8 7,8zM1,10L2,10 2,14 14,14 14,10 15,10 15,15 14,15 2,15 1,15z" })));
}
exports.default = Download;
//# sourceMappingURL=index.js.map